import { ReportScreen } from "@/features/report-screen";

/** The campaign report (ADR-074 in platform): what the dialer placed, what came of it, and where the leads went. Its screen is `features/report-screen.tsx`, shared with
 *  the other two reports. */
export function CampaignReportPage() {
  return <ReportScreen kind="campaigns" />;
}
